export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: ComicCategory[] = [
  {
    slug: 'romance',
    name: '浪漫爱情',
    icon: 'ri-heart-line',
    description: '甜到心坎里的浪漫故事，感受韩式恋爱的独特魅力',
  },
  {
    slug: 'action',
    name: '热血动作',
    icon: 'ri-fire-line',
    description: '激烈打斗、超燃剧情，肾上腺素飙升的阅读体验',
  },
  {
    slug: 'fantasy',
    name: '奇幻冒险',
    icon: 'ri-magic-line',
    description: '穿越异世界、魔法与剑，天马行空的奇幻旅程',
  },
  {
    slug: 'thriller',
    name: '悬疑惊悚',
    icon: 'ri-moon-line',
    description: '扣人心弦的悬疑剧情，每一页都让你屏息凝神',
  },
  {
    slug: 'comedy',
    name: '轻松喜剧',
    icon: 'ri-emotion-laugh-line',
    description: '爆笑日常、欢乐吐槽，治愈所有不开心',
  },
  {
    slug: 'drama',
    name: '都市剧情',
    icon: 'ri-building-line',
    description: '职场、校园、家庭，贴近生活的真实故事',
  },
  {
    slug: 'historical',
    name: '古风历史',
    icon: 'ri-ancient-gate-line',
    description: '华丽古装、宫廷权谋，穿越时空的传奇故事',
  },
  {
    slug: 'horror',
    name: '恐怖灵异',
    icon: 'ri-ghost-line',
    description: '毛骨悚然的灵异故事，胆小慎入的惊悚体验',
  },
];